'use client';
import Countdown, { zeroPad } from 'react-countdown';

import { Stack, Typography } from '@mui/material';

const Item = ({ time, label }: { time: number; label: string }) => {
  return (
    <Stack alignItems="center">
      <Typography
        className={`text-[#F0E9CF] text-[16px] leading-[22px] md:text-[20px] md:leading-[24px] font-ms_serif `}
      >
        {`${zeroPad(time)}${label}`}
      </Typography>
    </Stack>
  );
};

interface CountDownProps {
  date: string | Date;
}
function CountDown(props: CountDownProps) {
  const { date } = props;

  return (
    <Countdown
      date={date}
      renderer={({ days, hours, minutes, seconds }) => (
        <div className={'flex flex-grow gap-[4px] justify-end'}>
          <Item time={days} label="d" />
          <Item time={hours} label="h" />
          <Item time={minutes} label="m" />
          <Item time={seconds} label="s" />
        </div>
      )}
    />
  );
}

export default CountDown;
